const endedCallOrders = new Set<string>()
const connectingCallOrders = new Set<string>()

export function markCallOrderEnded(orderID: string) {
  if (orderID) {
    endedCallOrders.add(orderID)
  }
}

export function clearCallOrderEnded(orderID: string) {
  if (orderID) {
    endedCallOrders.delete(orderID)
  }
}

export function isCallOrderEnded(orderID: string) {
  return Boolean(orderID && endedCallOrders.has(orderID))
}

export function markCallOrderConnecting(orderID: string) {
  if (orderID) {
    connectingCallOrders.add(orderID)
  }
}

export function clearCallOrderConnecting(orderID: string) {
  if (orderID) {
    connectingCallOrders.delete(orderID)
  }
}

export function isCallOrderConnecting(orderID: string) {
  return Boolean(orderID && connectingCallOrders.has(orderID))
}

export function resetCallOrderLifecycleGuard() {
  endedCallOrders.clear()
  connectingCallOrders.clear()
}

export function resetEndedCallOrders() {
  endedCallOrders.clear()
}

export function resetConnectingCallOrders() {
  connectingCallOrders.clear()
}
